var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0C5.03708 0 0 5.03708 0 11.25C0 17.4629 5.03708 22.5 11.25 22.5C17.4629 22.5 22.5 17.4629 22.5 11.25C22.5 5.03708 17.4629 0 11.25 0ZM16.4423 12.9808H11.25C11.0205 12.9808 10.8004 12.8896 10.6381 12.7273C10.4758 12.565 10.3846 12.3449 10.3846 12.1154V4.32692C10.3846 4.09741 10.4758 3.8773 10.6381 3.715C10.8004 3.55271 11.0205 3.46154 11.25 3.46154C11.4795 3.46154 11.6996 3.55271 11.8619 3.715C12.0242 3.8773 12.1154 4.09741 12.1154 4.32692V11.25H16.4423C16.6718 11.25 16.8919 11.3412 17.0542 11.5035C17.2165 11.6658 17.3077 11.8859 17.3077 12.1154C17.3077 12.3449 17.2165 12.565 17.0542 12.7273C16.8919 12.8896 16.6718 12.9808 16.4423 12.9808Z",
    fill: "#C71002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.2472131c004d6196c57f18e751a7533f.svg";
export { ForwardRef as ReactComponent };